import { useMemo, useState } from 'react';

import { ETaskId } from 'common/contracts';
import { ESelfServeTaskStatus } from 'common/contracts';
import { useChecklistState } from 'state/hooks/setup-checklist.hook';

import Button from 'components/Button/Button';
import { DialogDescription, DialogHeader, DialogTitle } from 'components/ui';

const Header: React.FC<{ hasSubmitted: boolean }> = ({ hasSubmitted }) => (
  <DialogHeader className="flex flex-col gap-1.5 text-center">
    <DialogTitle className="flex flex-col gap-1.5 text-center my-auto text-2xl">
      {hasSubmitted ? 'Agreement Sent' : 'Sign Agreement'}
    </DialogTitle>
    <DialogDescription className="text-base-mutedForeground font-normal text-sm text-center">
      {hasSubmitted
        ? 'We’ve sent the agreement to your email. You can always come back here if you need us to resend it.'
        : 'Click below and we’ll send the agreement to your email.'}
    </DialogDescription>
  </DialogHeader>
);

export const SignAgreementFormContainer: React.FC = () => {
  const { setTaskStatus, categories } = useChecklistState();
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);

  const taskStatus = categories
    ?.find((c) => c.title === 'Sign agreement')
    ?.tasks.find((t) => t.id === ETaskId.SIGN_AGREEMENT)?.status;

  const hasSubmitted = useMemo(
    () =>
      taskStatus === ESelfServeTaskStatus.DONE ||
      taskStatus === ESelfServeTaskStatus.PENDING,
    [taskStatus]
  );

  const handleVerifyBusinessFormSubmit = () => {
    // TODO: API call to send agreement
    // TODO: On success request:
    setTaskStatus(ETaskId.SIGN_AGREEMENT, ESelfServeTaskStatus.PENDING);

    if (hasSubmitted) {
      setIsLoadingSubmit(true);
      setTimeout(() => {
        setIsLoadingSubmit(false);
      }, 5000);
    }
  };

  return (
    <div className="flex flex-col p-6 w-full items-center justify-between text-center">
      <Header hasSubmitted={!!hasSubmitted} />
      <Button
        onClick={handleVerifyBusinessFormSubmit}
        className="bg-base-primary hover:bg-button-hover-default text-base-primaryForeground font-normal"
        type="submit"
        isLoading={isLoadingSubmit}
      >
        {hasSubmitted ? 'Resend Email' : 'Get Agreement by Email'}
      </Button>
    </div>
  );
};
